import { EpimsBaseEntityDto } from './epim-base.dto';

import { IsNotEmpty } from 'class-validator';
import { ProjectTypeDto } from './project-type.dto';
import { ClusterDto } from './cluster.dto';

export class ProjectCategoryDto extends EpimsBaseEntityDto {
	@IsNotEmpty() ProjectCategoryId: string;
	@IsNotEmpty() ProjectCategoryName: string;
  projectTypes?: ProjectTypeDto[];
  clusters?: ClusterDto[]
}
